import {Box, CircularProgress, SxProps, Theme} from '@mui/material';
import useDownloadStorageFile from '../../hooks/helper/useDownloadStorageFile';

export interface ImageDisplayFromStorageProps {
  imageUrl?: string | null;
  sx?: SxProps<Theme>;
}

export default function ImageDisplayFromStorage({imageUrl, sx}: ImageDisplayFromStorageProps) {
  const {url, loading} = useDownloadStorageFile(imageUrl || undefined);

  if (!imageUrl) {
    return null;
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 200,
          bgcolor: 'grey.100',
          borderRadius: 1,
          ...sx,
        }}
        data-testid="image-display-from-storage"
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (!url) {
    return null;
  }

  return (
    <Box
      component="img"
      src={url}
      alt="Question image"
      sx={{
        maxWidth: '100%',
        height: 'auto',
        borderRadius: 1,
        display: 'block',
        ...sx,
      }}
      data-testid="image-display-from-storage"
      onError={(e) => {
        // Hide image on error
        const target = e.target as HTMLImageElement;
        target.style.display = 'none';
      }}
    />
  );
}
